import { FETCH_HEALTH_TAG_REQUEST } from "./constants";
import { combineReducers } from "redux";
import { Action } from "./types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { HealthTag } from "../types";

function item(state: Partial<HealthTag> = {}, action: Action): Partial<HealthTag> {
  switch (action.type) {
    case getSuccessActionType(FETCH_HEALTH_TAG_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_HEALTH_TAG_REQUEST:
      return true;

    case getSuccessActionType(FETCH_HEALTH_TAG_REQUEST):
    case getFailureActionType(FETCH_HEALTH_TAG_REQUEST):
      return false;

    default:
      return state;
  }
}

export const healthTag = combineReducers({ item, isFetching });
